import { x } from '@xstyled/styled-components';
import React from 'react';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';

export const AudioProgress = ({ w }: { w?: string }) => {
  const progress = useMediaPlayerStore(s => s.progress);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const progressAsNumber = parseFloat(progress);

  return (
    <x.div
      w={w || '250px'}
      h="7px"
      borderRadius="3px"
      backgroundColor="greenLight"
    >
      <x.div
        style={{
          width: `${Math.floor(progressAsNumber * 100)}%`
        }}
        borderRadius="3px"
        h="100%"
        backgroundColor="accentDark"
        transition="width ease-in-out 0.3s"
      />
    </x.div>
  );
};
